import { render, staticRenderFns } from "./OpenDeposit.vue?vue&type=template&id=867459ec"
import script from "./OpenDeposit.vue?vue&type=script&lang=js"
export * from "./OpenDeposit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports